export default __webpack_public_path__ + "static/media/MoreThanJust.7ae6ff63.webp";